export const abbreviate = (...args: string[]): string => {
	return args
		.map((e) => e.charAt(0))
		.join('')
		.toUpperCase()
}
